// # Login/Logout Activity Manager
import { functions, auth } from './firebase';
import { httpsCallable } from 'firebase/functions';

class LoginOutManager {
  constructor() {
    // # Initialize Firebase functions
    this.recordSignIn = httpsCallable(functions, 'recordSignIn');
    this.recordSignOut = httpsCallable(functions, 'recordSignOut');
  }

  // # Generate device ID
  _generateDeviceId() {
    const platform = navigator.platform;
    const cores = navigator.hardwareConcurrency;
    const userAgent = navigator.userAgent;
    // # Create a unique device fingerprint
    return btoa(`${platform}-${cores}-${userAgent}`).replace(/[/+=]/g, '').slice(0, 32);
  }

  // # Get device info
  async _getDeviceInfo() {
    const token = await auth.currentUser?.getIdToken() || 'unknown';
    const deviceId = this._generateDeviceId();
    
    return {
      device: `${navigator.platform} - ${navigator.userAgent}`,
      ip: 'client', // IP will be determined server-side for security
      session_token: token, // Add raw session token (non-functional)
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      device_id: deviceId,
      hardware_concurrency: navigator.hardwareConcurrency || 'unknown'
    };
  }

  // # Record sign in activity
  async recordSignInActivity(uid) {
    try {
      const deviceInfo = await this._getDeviceInfo();
      const result = await this.recordSignIn(deviceInfo);
      console.log('Sign in activity recorded:', result.data);
      return result.data;
    } catch (error) {
      console.error('Error recording sign in activity:', error);
      // # Propagate the error instead of returning null
      throw error;
    }
  }

  // # Record sign out activity
  async recordSignOutActivity(uid) {
    try {
      const deviceInfo = await this._getDeviceInfo();
      const result = await this.recordSignOut(deviceInfo);
      console.log('Sign out activity recorded:', result.data);
      return result.data;
    } catch (error) {
      console.error('Error recording sign out activity:', error);
      // # Propagate the error instead of returning null
      throw error;
    }
  }
}

// # Create singleton instance
const loginOutManager = new LoginOutManager();

export default loginOutManager;
